<template>
  <div id="my-content">
    <Header/>
    <main id="root">
      <section id="artist_djk_x-profile" class="artist-section section">

        <div class="artist-header__mobile">

          <button @click="btnBack" class="back-btn">
            <svg width="28" height="10" viewBox="0 0 28 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M27.1699 5.51286H2.41621L5.99017 9.08683L5.18712 9.88988L0.242188 4.94494L5.18712 0L5.99017 0.803047L2.41621 4.37701H27.1699V5.51286Z"/>
            </svg>
            <span class="back-btn-text">Back</span>
          </button>

          <div class="artist__background-gradient"></div>

          <div class="artist-profile-photo">
            <img v-if="!artistPhotoError && artist.photo" :src="artist.photo" alt="Artist photo" class="artist-img" loading="lazy" @error="artistPhotoErrorHandler">
            <img v-else src="@/assets/img/default-account-image.png" alt="Default artist photo" class="artist-img" loading="lazy">
          </div>

          <div class="artist-profile-photo-genre-list" v-if="publicInfo.genre">
            <!-- if genres as more as one-->
            <div v-if="moreGenres">
              <div class="artist-profile-photo-genre"
                   v-for="(item, index) in publicInfo.genre"
                   :key="index"
                   v-text="item"
              ></div>
            </div>
            <!-- ======================= -->
            <div class="artist-profile-photo-genre"
                 v-else
                 v-text="publicInfo.genre"
            ></div>
          </div>

          <div class="artist-profile-verified" v-if="checkUserProfile">
            <svg v-if="verifiedArtist"
                 width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M30.25 15.2351V16.5001C30.2483 19.4651 29.2882 22.3502 27.5128 24.7251C25.7375 27.0999 23.242 28.8372 20.3986 29.6779C17.5552 30.5186 14.5162 30.4177 11.7349 29.3901C8.95356 28.3626 6.5789 26.4634 4.96507 23.976C3.35124 21.4886 2.58471 18.5461 2.77981 15.5875C2.9749 12.6288 4.12116 9.81251 6.04763 7.55853C7.97411 5.30456 10.5776 3.73371 13.4698 3.08026C16.3619 2.42681 19.3879 2.72577 22.0963 3.93256" stroke="#459BCB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M30.25 5.5L16.5 19.2638L12.375 15.1388" stroke="#459BCB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <router-link v-else :to="{path: '/profile/kyc'}">
              <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.5 30.25C24.0939 30.25 30.25 24.0939 30.25 16.5C30.25 8.90608 24.0939 2.75 16.5 2.75C8.90608 2.75 2.75 8.90608 2.75 16.5C2.75 24.0939 8.90608 30.25 16.5 30.25Z" stroke="#CB8D45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M20.625 12.375L12.375 20.625" stroke="#CB8D45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.375 12.375L20.625 20.625" stroke="#CB8D45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </router-link>
          </div>

          <router-link :to="{path: `/company/${artist.companyManager.userName}`}" class="artist-profile-photo__company" v-if="artist.companyManager">
            <img v-if="artist.companyManager.avatar" :src="artist.companyManager.avatar" class="company-img" alt="Company manager image" loading="lazy">
            <img v-else src="@/assets/img/company-avatar__default.png" class="company-img" alt="Default company manager image" loading="lazy">
          </router-link>

        </div>

        <div class="container-small">
          <div class="artist-head-wrap desktop">
            <button @click="btnBack" class="back-btn">
              <svg width="28" height="10" viewBox="0 0 28 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M27.1699 5.51286H2.41621L5.99017 9.08683L5.18712 9.88988L0.242188 4.94494L5.18712 0L5.99017 0.803047L2.41621 4.37701H27.1699V5.51286Z"/>
              </svg>
              <span class="back-btn-text">Back</span>
            </button>
          </div>

          <div class="artist" v-if="isFlag">

            <div class="artist-profile">

              <div class="artist-profile-photo-wrapper desktop">
                <div class="artist__background-gradient"></div>
                <div class="artist-profile-photo">
                  <img v-if="!artistPhotoError && artist.photo" :src="artist.photo" alt="Artist photo" class="artist-img" loading="lazy" @error="artistPhotoErrorHandler">
                  <img v-else src="@/assets/img/default-account-image.png" alt="Default artist photo" class="artist-img" loading="lazy">
                </div>
                <div class="artist-profile-photo-genre-list" v-if="publicInfo.genre">
                <!-- if genres as more as one-->
                  <div v-if="moreGenres">
                    <div class="artist-profile-photo-genre"
                         v-for="(item, index) in publicInfo.genre"
                         :key="index"
                         v-text="item"
                    ></div>
                  </div>
                <!-- ======================== -->
                  <div class="artist-profile-photo-genre"
                       v-else
                       v-text="publicInfo.genre"
                  ></div>
                </div>

                <div class="artist-profile-verified" v-if="checkUserProfile">
                  <svg v-if="verifiedArtist"
                       width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M30.25 15.2351V16.5001C30.2483 19.4651 29.2882 22.3502 27.5128 24.7251C25.7375 27.0999 23.242 28.8372 20.3986 29.6779C17.5552 30.5186 14.5162 30.4177 11.7349 29.3901C8.95356 28.3626 6.5789 26.4634 4.96507 23.976C3.35124 21.4886 2.58471 18.5461 2.77981 15.5875C2.9749 12.6288 4.12116 9.81251 6.04763 7.55853C7.97411 5.30456 10.5776 3.73371 13.4698 3.08026C16.3619 2.42681 19.3879 2.72577 22.0963 3.93256" stroke="#459BCB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M30.25 5.5L16.5 19.2638L12.375 15.1388" stroke="#459BCB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <router-link v-else :to="{path: '/profile/kyc'}">
                    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16.5 30.25C24.0939 30.25 30.25 24.0939 30.25 16.5C30.25 8.90608 24.0939 2.75 16.5 2.75C8.90608 2.75 2.75 8.90608 2.75 16.5C2.75 24.0939 8.90608 30.25 16.5 30.25Z" stroke="#CB8D45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M20.625 12.375L12.375 20.625" stroke="#CB8D45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12.375 12.375L20.625 20.625" stroke="#CB8D45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </router-link>
                </div>

                <router-link :to="{path: `/company/${artist.companyManager.userName}`}" class="artist-profile-photo__company" v-if="artist.companyManager">
                  <span class="artist-profile-photo__company-text">sign by</span>
                  <img v-if="artist.companyManager.avatar" :src="artist.companyManager.avatar" class="company-img" alt="Company manager image" loading="lazy">
                  <img v-else src="@/assets/img/company-avatar__default.png" class="company-img" alt="Default company manager image" loading="lazy">
                </router-link>

              </div>

              <div class="artist-profile-info">

                <div class="artist-profile-info-header">

                  <div class="artist-profile-info-header-top">
                    <div class="artist-profile-head-name" v-text="userName"></div>
                    <div class="artist-profile-headline" v-text="artist.headline"></div>
                  </div>

                  <div class="artist-profile-info-header-bottom">

                    <div class="artist-profile-short-info">
                      <svg width="27" height="17" viewBox="0 0 27 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.2401 7.22638C20.2362 7.22638 21.8354 5.6151 21.8354 3.61905C21.8354 1.62299 20.2362 0.0117188 18.2401 0.0117188C16.2441 0.0117188 14.6328 1.62299 14.6328 3.61905C14.6328 5.6151 16.2441 7.22638 18.2401 7.22638ZM8.62296 7.22638C10.619 7.22638 12.2183 5.6151 12.2183 3.61905C12.2183 1.62299 10.619 0.0117188 8.62296 0.0117188C6.6269 0.0117188 5.01562 1.62299 5.01562 3.61905C5.01562 5.6151 6.6269 7.22638 8.62296 7.22638ZM8.62023 9.63086C5.81854 9.63086 0.203125 11.0377 0.203125 13.8394V15.6431C0.203125 16.3044 0.744225 16.8455 1.40557 16.8455H15.8349C16.4962 16.8455 17.0373 16.3044 17.0373 15.6431V13.8394C17.0373 11.0377 11.4219 9.63086 8.62023 9.63086ZM18.2367 9.63086C17.888 9.63086 17.4912 9.65491 17.0703 9.69098C17.0944 9.703 17.1064 9.72705 17.1184 9.73908C18.4892 10.7371 19.4391 12.0718 19.4391 13.8394V15.6431C19.4391 16.0639 19.355 16.4728 19.2227 16.8455H25.4513C26.1127 16.8455 26.6538 16.3044 26.6538 15.6431V13.8394C26.6538 11.0377 21.0384 9.63086 18.2367 9.63086Z" fill="#B4B4B4"/>
                      </svg>
                      <span class="artist-profile-short-info-text"
                           v-text="artist.numberOfSubscriber ? `${artist.numberOfSubscriber} Subscribers` : '0 Subscribers'"
                      ></span>
                    </div>

                    <div class="artist-profile-short-info">
                      <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0859375 7.5C0.0859375 3.35786 3.4438 -1.19209e-06 7.58594 0C11.7281 0 15.0859 3.35787 15.0859 7.5C15.0859 12.5 7.58594 20 7.58594 20C7.58594 20 0.0859375 12.5 0.0859375 7.5ZM4.46094 7.5C4.46094 9.22589 5.86005 10.625 7.58594 10.625C9.31183 10.625 10.7109 9.22589 10.7109 7.5C10.7109 5.77411 9.31183 4.375 7.58594 4.375C5.86005 4.375 4.46094 5.77411 4.46094 7.5H4.46094Z" fill="#B4B4B4"/>
                      </svg>
                      <span class="artist-profile-short-info-text"
                            v-text="artist.country"
                      ></span>
                    </div>

                    <div class="artist-profile-short-info">
                      <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.8692 3.76299L9.20256 0.2332C8.8473 -0.0338314 8.37271 -0.0748574 7.97757 0.127305C7.58524 0.326681 7.33724 0.731418 7.3359 1.17448V11.2461C6.63125 10.8184 5.82503 10.5907 5.00258 10.5872C2.42527 10.5872 0.335938 12.6944 0.335938 15.2936C0.335938 17.8929 2.42527 20 5.00258 20C7.5799 20 9.66922 17.8929 9.66922 15.2936V3.52767L12.4692 5.64554C12.9847 6.03543 13.7159 5.93007 14.1025 5.41022C14.4891 4.89037 14.3847 4.15288 13.8692 3.76299Z" fill="#B4B4B4"/>
                      </svg>
                      <span class="artist-profile-short-info-text"
                            v-text="artist.numberOfSongs > 30 ? '30+ Songs repertoire' : `${artist.numberOfSongs} Songs repertoire`"
                      ></span>
                    </div>

                  </div>

                </div>

                <div class="artist-profile-info-main" v-if="artist.description">
                  <div class="artist-profile-info-description">
                    {{ description }}
                    <div class="artist-profile-description-btn-wrap"
                         v-if="artist.description.length > 220"
                    >

                      <button class="artist-profile-description-btn"
                              @click="openFullDescription"
                              v-if="description.length <= 220"
                      >read more</button>
                      <button class="artist-profile-description-btn"
                              @click="closeFullDescription"
                              v-else
                      >hide</button>

                    </div>
                  </div>
                </div>

                <div class="artist-profile-info-footer">
                  <div class="artist-profile-social-wrap" v-if="artist.links">
                    <div class="artist-profile-info-social-title">Social media:</div>
                    <div class="artist-profile-social-list">
                      <div class="artist-profile-social-item" v-if="artist.links && artist.links.website">
                        <a :href="artist.links.website" target="_blank">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1 12C1 11.4477 1.44772 11 2 11H22C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H2C1.44772 13 1 12.5523 1 12Z"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.00023 12.0001C9.06877 15.0749 10.1263 18.0353 12 20.4493C13.8737 18.0353 14.9312 15.0749 14.9998 12.0001C14.9312 8.92527 13.8737 5.96495 12 3.5509C10.1263 5.96495 9.06877 8.92527 9.00023 12.0001ZM12 2.00011L11.2617 1.32568C8.59689 4.24301 7.08251 8.02896 7.00022 11.9793C6.99993 11.9932 6.99993 12.0071 7.00022 12.0209C7.08251 15.9713 8.59689 19.7572 11.2617 22.6745C11.4511 22.8819 11.7191 23.0001 12 23.0001C12.2809 23.0001 12.5489 22.8819 12.7383 22.6745C15.4031 19.7572 16.9175 15.9713 16.9998 12.0209C17.0001 12.0071 17.0001 11.9932 16.9998 11.9793C16.9175 8.02896 15.4031 4.24301 12.7383 1.32568L12 2.00011Z"/>
                          </svg>
                        </a>
                      </div>
                      <div class="artist-profile-social-item" v-if="artist.links && artist.links.twitter">
                        <a :href="artist.links.twitter" target="_blank">
                          <svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5256 1.35024C15.5744 0.949932 16.7208 0.881388 17.8099 1.15388C18.6759 1.37057 19.4724 1.7946 20.1327 2.38515C20.9449 2.08663 21.7152 1.68262 22.4237 1.18288L23.0001 2.00005L23.9717 2.23666C23.6292 3.64319 22.9426 4.93961 21.977 6.01102C21.9918 6.17242 21.9996 6.33448 22.0001 6.49674L22.0001 6.50005C22.0001 12.6 19.0632 17.0751 14.845 19.3203C10.651 21.5525 5.29097 21.5278 0.51446 18.8742C0.109649 18.6493 -0.0877967 18.1759 0.0372519 17.73C0.162301 17.2841 0.577127 16.9824 1.03985 17.0008C2.72666 17.0679 4.39647 16.7325 5.91484 16.033C4.41169 15.1055 3.32952 14.0043 2.57716 12.8163C1.57353 11.2317 1.19466 9.55295 1.12613 8.04545C1.05781 6.54233 1.29658 5.18894 1.54758 4.21841C1.67368 3.73082 1.80452 3.33355 1.90538 3.05458C1.95587 2.91493 1.99901 2.80446 2.03054 2.72663C2.04631 2.6877 2.0592 2.65689 2.06866 2.63464L2.08023 2.60771L2.08319 2.60096C2.09023 2.58478 2.09773 2.56873 2.10568 2.55283L3.0001 3.00005L3.81846 2.42534C4.734 3.72901 5.95775 4.78604 7.38071 5.50226C8.51256 6.07196 9.7425 6.41197 10.9998 6.50646C10.9924 5.3968 11.3221 4.3107 11.9457 3.3921C12.5762 2.4633 13.4768 1.75054 14.5256 1.35024ZM3.40475 5.04365C3.22106 5.84502 3.07437 6.86128 3.12407 7.95464C3.18055 9.19714 3.48918 10.5184 4.2668 11.7462C5.04039 12.9677 6.31614 14.1573 8.40624 15.0862C8.73804 15.2337 8.96384 15.5494 8.99614 15.9111C9.02844 16.2728 8.86216 16.6235 8.56173 16.8274C7.4508 17.5815 6.2343 18.1489 4.9602 18.5157C8.13037 19.3234 11.3071 18.9377 13.9053 17.5548C17.4366 15.6752 19.9996 11.9009 20.0001 6.50171C19.9993 6.28562 19.9785 6.07006 19.9379 5.8578C19.8752 5.52994 19.9803 5.19242 20.2179 4.95804C20.4407 4.73835 20.647 4.50421 20.8358 4.25755C20.6093 4.3411 20.3801 4.41783 20.1484 4.48758C19.7718 4.60099 19.3637 4.48308 19.1055 4.18628C18.6377 3.64837 18.016 3.26711 17.3244 3.09407C16.6328 2.92102 15.9048 2.96455 15.2388 3.21876C14.5727 3.47297 14.0009 3.9256 13.6005 4.51542C13.2001 5.10525 12.9905 5.80381 13 6.51664L13.0002 6.53005H13.0001V7.53005C13.0001 8.07223 12.568 8.51566 12.026 8.52971C10.1038 8.57955 8.19909 8.15324 6.48152 7.28872C5.33595 6.71212 4.29735 5.95253 3.40475 5.04365Z" fill="#EC008C"/>
                          </svg>
                        </a>
                      </div>
                      <div class="artist-profile-social-item" v-if="artist.links && artist.links.instagram">
                        <a :href="artist.links.instagram" target="_blank">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7 3C4.79086 3 3 4.79086 3 7V17C3 19.2091 4.79086 21 7 21H17C19.2091 21 21 19.2091 21 17V7C21 4.79086 19.2091 3 17 3H7ZM1 7C1 3.68629 3.68629 1 7 1H17C20.3137 1 23 3.68629 23 7V17C23 20.3137 20.3137 23 17 23H7C3.68629 23 1 20.3137 1 17V7Z" fill="#EC008C"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4869 8.98924C11.8627 8.89668 11.2253 9.0033 10.6652 9.29392C10.1051 9.58455 9.65087 10.0444 9.36718 10.608C9.08348 11.1717 8.98473 11.8104 9.08498 12.4334C9.18523 13.0564 9.47937 13.6319 9.92556 14.0781C10.3718 14.5243 10.9473 14.8184 11.5703 14.9187C12.1933 15.0189 12.832 14.9202 13.3957 14.6365C13.9593 14.3528 14.4191 13.8986 14.7097 13.3385C15.0004 12.7784 15.107 12.1409 15.0144 11.5167C14.92 10.88 14.6233 10.2906 14.1682 9.83547C13.7131 9.38034 13.1236 9.08366 12.4869 8.98924ZM9.74403 7.51868C10.6775 7.0343 11.74 6.85661 12.7803 7.01087C13.8415 7.16823 14.8239 7.6627 15.5824 8.42126C16.341 9.17981 16.8354 10.1622 16.9928 11.2234C17.1471 12.2637 16.9694 13.3261 16.485 14.2596C16.0006 15.1931 15.2342 15.9501 14.2948 16.423C13.3554 16.8958 12.2909 17.0604 11.2525 16.8933C10.2142 16.7262 9.255 16.236 8.51135 15.4923C7.76769 14.7487 7.27746 13.7895 7.11038 12.7511C6.9433 11.7128 7.10788 10.6482 7.58071 9.70884C8.05353 8.76944 8.81053 8.00305 9.74403 7.51868Z" fill="#EC008C"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 6.5C16.5 5.94772 16.9477 5.5 17.5 5.5H17.51C18.0623 5.5 18.51 5.94772 18.51 6.5C18.51 7.05228 18.0623 7.5 17.51 7.5H17.5C16.9477 7.5 16.5 7.05228 16.5 6.5Z" fill="#EC008C"/>
                          </svg>
                        </a>
                      </div>
                      <div class="artist-profile-social-item" v-if="artist.links && artist.links.facebook">
                        <a :href="artist.links.facebook" target="_blank">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7574 2.75736C11.8826 1.63214 13.4087 1 15 1H18C18.5523 1 19 1.44772 19 2V6C19 6.55228 18.5523 7 18 7H15V9H18C18.3079 9 18.5987 9.14187 18.7882 9.38459C18.9777 9.6273 19.0448 9.94379 18.9701 10.2425L17.9701 14.2425C17.8589 14.6877 17.4589 15 17 15H15V22C15 22.5523 14.5523 23 14 23H10C9.44772 23 9 22.5523 9 22V15H7C6.44772 15 6 14.5523 6 14V10C6 9.44772 6.44772 9 7 9H9V7C9 5.4087 9.63214 3.88258 10.7574 2.75736ZM15 3C13.9391 3 12.9217 3.42143 12.1716 4.17157C11.4214 4.92172 11 5.93913 11 7V10C11 10.5523 10.5523 11 10 11H8V13H10C10.5523 13 11 13.4477 11 14V21H13V14C13 13.4477 13.4477 13 14 13H16.2192L16.7192 11H14C13.4477 11 13 10.5523 13 10V7C13 6.46957 13.2107 5.96086 13.5858 5.58579C13.9609 5.21071 14.4696 5 15 5H17V3H15Z" fill="#EC008C"/>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="artist-subscribe-btn-wrap" v-if="isLogged && checkUserProfile">
                    <router-link :to="{path: '/profile/'}" class="btn btn-hover artist-profile-follow-btn">
                      Edit
                    </router-link>
                  </div>

                  <div class="artist-subscribe-btn-wrap" v-if="isLogged && !checkUserProfile">

                    <button @click="followAll"
                            class="btn btn-hover artist-profile-follow-btn"
                            v-if="!artist.subscribedSinger">Follow</button>

                    <button @click="unfollowAll"
                            class="btn btn-hover artist-profile-follow-btn"
                            v-else>Unfollow</button>

                  </div>

                  <div v-if="!isLogged" class="artist-subscribe-btn-wrap">
                    <router-link :to="{path: '/login'}" class="btn btn-hover artist-profile-follow-btn">
                      Login or Register to follow
                    </router-link>
                  </div>

                </div>

              </div>

            </div>

            <div class="artist-open-ieo-wrap">
<!--              <audio src="" id="hitplayer" autoplay="false"></audio>-->
              <div class="artist-ieos"
                   v-if="ieosOpen.length"
              >
                <h2 class="artist-open-ieo--title">open Initial Sale</h2>
                <carousel
                    :autoplay="false"
                    :nav="navFlag"
                    :dots="dotsFlag"
                    :items="sliderItemCount"
                    :margin="15"
                    v-if="isFlag"
                >
                  <ArtistProfileList
                      v-for="(ieo, index) in ieosOpen"
                      :key="index"
                      :ieo="ieo"
                      :index="index"
                      :identifier="'artist-profile-open-item'"
                      :isLogged="isLogged"
                      @followIeo="follow"
                      @unfollowIeo="unfollow"
                      :current="current"
                      @playingMusic="compareSongs"
                      @serverError="serverErrorFunc"
                  />
                </carousel>
              </div>
              <div class="artist-ieos"
                   v-if="ieosSuccess.length"
              >
                <h2 class="artist-open-ieo--title">Successful auctions</h2>
                <carousel
                    :autoplay="false"
                    :nav="navFlag"
                    :dots="dotsFlag"
                    :items="sliderItemCount"
                    :margin="15"
                    v-if="isFlag"
                >
                  <ArtistProfileList
                      v-for="(ieo, index) in ieosSuccess"
                      :key="index"
                      :index="index"
                      :identifier="'artist-profile-success-item'"
                      :ieo="ieo"
                      :isLogged="isLogged"
                      @followIeo="follow"
                      @unfollowIeo="unfollow"
                      :current="current"
                      @playingMusic="compareSongs"
                      @serverError="serverErrorFunc"
                  />
                </carousel>
              </div>
            </div>

          </div>

          <div class="preloader-wrapper" v-else>
            <v-progress-circular
                :size="75"
                :width="8"
                color="#FF0090"
                indeterminate
            ></v-progress-circular>
          </div>

        </div>
      </section>
      <server-error-popup ref="serverErrorPopup" :errorMessage="error.serverError"/>
      <video-popup ref="artistVideoPopup"/>
    </main>
    <Footer/>
  </div>
</template>

<script>
import Header from "../header/Header";
import Footer from "../footer/Footer";
import carousel from 'vue-owl-carousel2'
import ArtistProfileList from "./ArtistProfileList";
import {debounce} from "lodash";
import ServerErrorPopup from "../popups/ServerErrorPopup";
import VideoPopup from "../popups/VideoPopup";
import {mapGetters} from "vuex";
import nameHandler from "@/mixins/nameHandler";


export default {
  name: "ArtistProfile",
  data() {
    return {
      // Fake data:
      // showFakeData: false,
      // fakeGenres: ['pop','rib','check sound',],
      // userVerified: false,
      // ====
      userName: '',
      artistPhotoError: false,
      publicInfo: {},
      artist: {},
      isFlag: null,
      tabs: JSON.parse(localStorage.getItem('tabs')),
      sliderItemCount: 3,
      resizeWatcher: 3,
      loadFlag: false,
      current: '',
      navFlag: false,
      dotsFlag: true,
      description: '',
      ieos: [],
      ieosOpen: [],
      ieosSuccess: [],
      error: {
        serverError: ''
      },
    }
  },
  mixins: [nameHandler],
  computed: {
    ...mapGetters({
      isLogged: 'authentication/isLogged',
      user: 'user/getUser',
    }),
    checkUserProfile() {
      return this.user.userUuid === this.artist.singerId
    },
    verifiedArtist() {
      return this.tabs.kycTab.kycFlow === 'NONE'
    },
    moreGenres() {
      return this.publicInfo.genre === typeof Array && this.publicInfo.genre.length > 1
    },
  },
  methods: {
    artistPhotoErrorHandler() {
      console.log('awdawdaw')
      this.artistPhotoError = true
    },
    parseData(response) {
      this.artist = response.data.body
      this.publicInfo = response.data.body.commonPublicInformation
      if (response.data.body.ieos) {
        this.ieos = response.data.body.ieos
      }

      this.userName = this.getNameDefault(null, this.publicInfo.stageName, this.artist.firstName, this.artist.lastName)
      this.closeFullDescription()
    },
    serverErrorFunc(data) {
      this.error.serverError = data
      this.$refs.serverErrorPopup.openPopups()
    },
    lengthWatcher() {
      window.addEventListener("resize", () => {
        if (innerWidth > 1200) {
          this.resizeWatcher = 3
        }
        if (innerWidth <= 1199) {
          this.resizeWatcher = 2

        }
        if (innerWidth > 779) {
          this.dotsFlag = true
          this.navFlag = false
        }
        if (innerWidth < 779) {
          this.resizeWatcher = 1
          this.dotsFlag = false
          this.navFlag = true
        }
      }, false);

    },
    compareSongs() {
      this.current = localStorage.getItem('currentSongPlaying')
    },
    dataRequest() {
      if (this.isLogged) {
        this.$load(async () => {
          this.isFlag = false
          let response = (await this.$api.artistProfile.getAll(this.$route.params.id))
          this.parseData(response)
          this.isFlag = true
        })
      } else {
        this.$load(async () => {
          this.isFlag = false
          let response = (await this.$api.artistProfile.getAllUnauth(this.$route.params.id))
          this.parseData(response)
          this.isFlag = true
        })
      }
    },
    followAll() {
      this.$load(async () => {
        const artistId = this.artist.singerId
        await this.$api.followUnfollow.followAll(artistId)
        let response = (await this.$api.artistProfile.getAll(this.$route.params.id))
        this.artist = response.data.body
      }, error => {
        this.error.serverError = error.data.errors[0].message
        this.$refs.serverErrorPopup.openPopups()
      })
    },
    unfollowAll() {
      this.$load(async () => {
        const artistId = this.artist.singerId
        await this.$api.followUnfollow.unfollowAll(artistId)
        let response = (await this.$api.artistProfile.getAll(this.$route.params.id))
        this.artist = response.data.body
      }, error => {
        this.error.serverError = error.data.errors[0].message
        this.$refs.serverErrorPopup.openPopups()
      })
    },
    follow() {
      this.dataRequest()
    },
    unfollow() {
      this.dataRequest()
    },
    openVideoPopup() {
      this.$refs.artistVideoPopup.openPopup()
    },
    btnBack() {
      if (window.history) {
        window.history.back()
      } else {
        this.$router.push({path: '/artists', query: {page: '1', artist: 'djk-x'}})
      }
    },
    openFullDescription() {
      this.description =  this.artist.description
    },
    closeFullDescription() {
      if (this.artist.description) {
        this.description = this.artist.description.slice(0, 220)
      }
    },
  },
  watch: {
    'resizeWatcher'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.sliderItemCount = newVal
        this.debounceName()
      }
    },
    'ieos'() {
      if (this.ieos) {
        this.ieosOpen = this.ieos.filter(i => i.status === 'OPEN')
        this.ieosSuccess = this.ieos.filter(i => i.status === 'SUCCESS')
      }
    },
  },
  mounted() {
    document.title = 'Artist'

    // setTimeout(() => {
    //   this.closeFullDescription()
    // }, 500)

    this.dataRequest()

    this.lengthWatcher()
    this.debounceName = debounce(this.dataRequest, 500);

    if (window.innerWidth >= 1200) {
      this.sliderItemCount = 3
      debounce(this.dataRequest, 500);
      return
    }
    if (window.innerWidth >= 780) {
      this.sliderItemCount = 2
      debounce(this.dataRequest, 500);
    }

    if (window.innerWidth > 779) {
      this.dotsFlag = true
      this.navFlag = false
    }
    if (window.innerWidth < 779) {
      this.sliderItemCount = 1
      this.dotsFlag = false
      this.navFlag = true
      debounce(this.dataRequest, 500);
    }
  },
  components: {
    ArtistProfileList,
    Footer,
    Header,
    carousel,
    ServerErrorPopup,
    VideoPopup,
  }
}
</script>

<style scoped>

.preloader-wrapper {
  width: 100%;
}


</style>
